import { computed } from 'vue';
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";
import { FilterKey } from "@/models/FilterKey";
import { CountryFilterOptionInformation } from '@/models/CountryFilterOptionInformation';
import { FilterOptionInformation } from '@/models/FilterOptionInformation';

export class SelectedLocations {

	public constructor(
		private readonly filterProvider: IFilterProvider,
	) { }

	public countries = computed(() => {
		const selectedCountries = this.filterProvider.getFilterSelection(FilterKey.COUNTRY);
		return this.getCountryInformationFor([...selectedCountries]);
	});

	public continents = computed(() => {
		const selectedContinents = this.filterProvider.getFilterSelection(FilterKey.CONTINENT);
		return this.getContinentInformationFor([...selectedContinents]);
	});

	private getCountryInformationFor(ids: string[]): CountryFilterOptionInformation[] {
		const options: CountryFilterOptionInformation[] = [];

		ids.forEach((id) => {
			const filterOptionInformation = this.filterProvider.getFilterOptionInformationById(FilterKey.COUNTRY, id);
			if (filterOptionInformation != null) {
				options.push(filterOptionInformation as CountryFilterOptionInformation);
			}
		});

		return options;
	}

	private getContinentInformationFor(ids: string[]): FilterOptionInformation[] {
		const options: FilterOptionInformation[] = [];

		ids.forEach((id) => {
			const filterOptionInformation = this.filterProvider.getFilterOptionInformationById(FilterKey.CONTINENT, id);
			if (filterOptionInformation != null) {
				options.push(filterOptionInformation);
			}
		});

		return options;
	}
}
